'use client';
import React from 'react';

import Hooks from '@benzinga/hooks';
import { SessionContext } from '@benzinga/session-context';
import { SubscriptionsManager, SubscriptionsManagerEvent } from '@benzinga/subscription-manager';
import { BenzingaContext } from '../context';

/**
 * Hook to check whether user is trailing or not
 */
export const useIsUserTrialing = (productSlug?: string): boolean => {
  const session = React.useContext(SessionContext);
  const subscriptionManager = session.getManager(SubscriptionsManager);

  const benzingaContext = React.useContext(BenzingaContext);
  productSlug = productSlug ?? benzingaContext?.slug.product;

  const [isTrialing, setIsTrialing] = React.useState(subscriptionManager.isTrialing(productSlug));

  Hooks.useSubscriber(subscriptionManager, (event: SubscriptionsManagerEvent) => {
    switch (event.type) {
      case 'update_subscriptions':
        setIsTrialing(subscriptionManager.isTrialing(productSlug));
        break;
    }
  });

  React.useEffect(() => {
    setIsTrialing(subscriptionManager.isTrialing(productSlug));
  }, [productSlug, subscriptionManager]);

  return isTrialing;
};
